import { useState } from 'react';

function useHoverHandlers() {
    const [isHovering, setIsHovering] = useState<boolean>(false);

    const onMouseMove = () => {
        setIsHovering((prevIsHovering) => (prevIsHovering ? prevIsHovering : true));
    };

    const onMouseEnter = () => {
        setIsHovering(true);
    };

    const onMouseLeave = () => {
        setIsHovering(false);
    };

    return {
        isHovering,
        onMouseMove,
        onMouseEnter,
        onMouseLeave,
    };
}

export default useHoverHandlers;
